import { ProfileService } from '@/services/api'
import appConfig from '@/config.js'
import store from '@/store'
import utils from '@/mixins/utils.mixin'
import { legacyPreferencesToMigrate } from '@/common/preferencesStorage'

export default {
  state: {
    profile: {},
    roles: []
  },
  getters: {
    profile: state => {
      return state.profile
    },
    roles: state => {
      return state.roles
    },
    isSuperAdmin: state => {
      return state.roles.findIndex(x => x === window.roles.SUPER_ADMIN) !== -1
    },
    isOperatorSupervisor: (state, getters) => {
      return getters.isSuperAdmin || state.roles.findIndex(x => x === window.roles.OPERATOR_SUPERVISOR) !== -1
    },
    isGcmAdmin: (state, getters) => {
      return state.roles.findIndex(x => x === window.roles.GCM_ADMIN) !== -1
    },
    isCompanyAdmin: (state, getters) => {
      return getters.isSuperAdmin || state.roles.findIndex(x => x === window.roles.COMPANY_ADMIN) !== -1
    },
    addresses: state => {
      return []
    }
  },
  mutations: {
    setProfile(state, payload) {
      state.profile = payload
    },
    setRoles(state, payload) {
      state.roles = payload.map(x => x.name)
    }
  },
  actions: {
    async fetchProfile({ commit }) {
      await store.dispatch('setEcosystemModules', store.getters.eid)
      await store.dispatch('setEcosystemCountries')

      const payload = {
        params: {
          includes: [
            'platform_user_authorizations.platform.application',
            'company.applications.platform',
            'company.users',
            'company.stores.place',
            'company.marketing_settings.setting',
            'company.notification_configs'
          ]
        }
      }
      return ProfileService.get(payload)
        .then(response => {
          commit('setProfile', response.data)
          commit('setRoles', response.data.roles)
          if (response.data.company) {
            if (response.data.company.country_iso_code !== window.country) {
              document.cookie = 'country=' + response.data.company.country_iso_code + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
              window.country = response.data.company.country_iso_code
              document.cookie = 'phonePrefix=' + window.countries.find(x => x.iso_code === response.data.company.country_iso_code).front_config.i18n.phonePrefix + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
              window.phonePrefix = window.countries.find(x => x.iso_code === response.data.company.country_iso_code).front_config.i18n.phonePrefix
            }
            const frontConfig = window.countries.find(x => x.iso_code === response.data.company.country_iso_code).front_config
            commit('setFrontConfig', frontConfig)
            if (frontConfig.ecosystem) {
              commit('setEcosystem', frontConfig.ecosystem)
            }
          }

          if (response.data.meta?.persistentStorage) {
            for (const [key, value] of Object.entries(response.data.meta.persistentStorage)) {
              utils.methods.setLocalStorage(key, value, false)
            }
          }

          // Preferences stored under the old bare keys move to {product}.{ecosystem}.{type}
          const persistentStorage = response.data.meta?.persistentStorage || {}
          const migrated = legacyPreferencesToMigrate(persistentStorage, store.getters.eid)
          if (Object.keys(migrated).length > 0) {
            for (const [key, value] of Object.entries(migrated)) {
              utils.methods.setLocalStorage(key, value, false)
            }
            // Saved straight to the profile (not updateUser) to avoid another fetchProfile
            ProfileService.update({ meta: { ...(response.data.meta || {}), persistentStorage: { ...persistentStorage, ...migrated } } })
              .catch(e => console.error('Preferences migration could not be saved', e))
          }
        })
    },
    updateUser({ dispatch }, data) {
      return ProfileService.update(data)
        .then(response => {
          dispatch('fetchProfile')
        })
    },
    changePassword({ dispatch }, data) {
      return ProfileService.changePassword(data)
        .then(response => {
          dispatch('fetchProfile')
        })
    },
    emailPassword({ dispatch }, data) {
      return ProfileService.emailPassword(data)
    },
    resetPassword({ dispatch }, data) {
      return ProfileService.resetPassword(data)
    },
    checkAccessRules({ dispatch }) {
      let hasAccess = false
      for (const rule of appConfig.accessRules) {
        if (!hasAccess && store.getters[rule]) {
          hasAccess = true
        }
      }
      return hasAccess
    }
  }
}
